import { z } from 'zod';
import { route, defineContract } from '../core/types';
import { requiredStringSchema } from '../schemas';

const organizationIdParamsSchema = z.object({
	organizationId: requiredStringSchema,
});

export const organizationsContract = defineContract('organizations', {
	createOrganizationBucket: route({
		method: 'POST',
		path: '/:organizationId/bucket',
		params: organizationIdParamsSchema,
		response: z.string(),
		operationId: 'createOrganizationBucket',
		tags: ['Organizations Storage'],
		summary: 'Create an organization S3 bucket',
	}),
	// `/:organizationId/bucket`, not `/:organizationId`: this deletes the org's S3
	// bucket, not the organization — that is `DELETE /projectConfig/organization/
	// :organizationId` in another service. The POST twin above always named the
	// bucket; the DELETE read as if it destroyed the tenant.
	deleteOrganizationBucket: route({
		method: 'DELETE',
		path: '/:organizationId/bucket',
		params: organizationIdParamsSchema,
		response: z.string(),
		operationId: 'deleteOrganizationBucket',
		tags: ['Organizations Storage'],
		summary: 'Delete an organization S3 bucket',
	}),
	uploadOrganizationLogo: route({
		method: 'POST',
		path: '/:organizationId/logo',
		contentType: 'multipart/form-data',
		params: organizationIdParamsSchema,
		query: z.object({ theme: z.enum(['dark', 'light']) }),
		body: z.object({
			file: z.file(),
		}),
		response: z.string(),
		operationId: 'uploadOrganizationLogo',
		tags: ['Organizations Storage'],
		summary: 'Upload organization logo',
	}),
	getOrganizationLogo: route({
		method: 'GET',
		path: '/:organizationId/logo',
		params: organizationIdParamsSchema,
		query: z.object({ theme: z.enum(['dark', 'light']) }),
		response: z.any(),
		operationId: 'getOrganizationLogo',
		tags: ['Organizations Storage'],
		summary: 'Get organization logo',
	}),
});
